import React from "react";
import Card from "@mui/material/Card";
import CardHeader from "@mui/material/CardHeader";
import CardMedia from "@mui/material/CardMedia";
import CardContent from "@mui/material/CardContent";
import CardActions from "@mui/material/CardActions";
import Avatar from "@mui/material/Avatar";
import IconButton from "@mui/material/IconButton";
import Typography from "@mui/material/Typography";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faHeart,
  faComment,
  faPaperPlane,
  faEllipsisH,
  faBagShopping,
} from "@fortawesome/free-solid-svg-icons";
import {
  ChatBubbleOutlineOutlined,
  FavoriteBorderRounded,
  FavoriteRounded,
  SendOutlined,
  ShoppingBagOutlined,
} from "@mui/icons-material";

export default function PostCard(post) {
  const [like, setLike] = React.useState(false);
  const [likeNumber, setLikeNumber] = React.useState(post.post.likes.length);
  return (
    <Card className="w-full my-2 h-fit" key={post.post._id}>
      <CardHeader
        sx={{
          "& .MuiCardHeader-title": {
            fontWeight: "bold",
            marginLeft: "-0.5rem",
          },
          "& .MuiCardHeader-subheader": {
            marginLeft: "-0.5rem",
          },
        }}
        className="my-0 -mt-2 -mx-1"
        avatar={
          <Avatar
            sx={{
              borderRadius: "40%",
            }}
            src={post.post.user?.image}
            aria-label={post.post.user?.name}
          />
        }
        action={
          <>
            <div className="flex flex-row justify-center items-center">
              <p className="text-[0.7rem] text-black mr-2">
                {post.post.duration}
              </p>
              <IconButton aria-label="settings">
                <FontAwesomeIcon icon={faEllipsisH} width={15} color="black" />
              </IconButton>
            </div>
          </>
        }
        title={post.post.user?.name}
        subheader={"@" + post.post.user?.email.split("@")[0]}
      />
      {post.post?.image && (
        <CardMedia
          component="img"
          height="100%"
          image={post.post.image}
          alt={post.post.caption}
        />
      )}
      <CardContent className="flex flex-row ">
        <p> {post.post.caption}</p>

        {post.post?.category && (
          <div className="bg-black justify-center text-center items-center rounded-md text-white text-[0.6rem] w-[15vw] h-fit py-[0.3rem]">
            {post.post?.category}
          </div>
        )}
      </CardContent>
      <CardActions disableSpacing className="flex  justify-between -mt-4">
        <div>
          <IconButton
            className="flex flex-col "
            aria-label="like"
            onClick={() => {
              if (like) {
                setLikeNumber(likeNumber - 1);
              }
              if (!like) {
                setLikeNumber(likeNumber + 1);
              }
              setLike(!like);
            }}
          >
            {like ? (
              <FavoriteRounded className="text-red-600" />
            ) : (
              <FavoriteBorderRounded className="text-black" />
            )}
            <p className="text-[0.6rem] text-black">Love</p>
          </IconButton>
          <IconButton aria-label="share" className="flex flex-col">
            <ChatBubbleOutlineOutlined className="text-black" />
            <p className="text-[0.6rem] text-black">Comment</p>
          </IconButton>
          <IconButton aria-label="share" className="flex flex-col">
            <SendOutlined className="text-black" />
            <p className="text-[0.6rem] text-black">Share</p>
          </IconButton>
        </div>
        <IconButton aria-label="share" className="flex flex-col ">
          <ShoppingBagOutlined />
          <p className="text-[0.6rem] text-black">Add to cart</p>
        </IconButton>
      </CardActions>
      <CardActions className="-mt-4">
        <p className="text-[0.7rem] ml-2">{likeNumber} Loves</p>
        <p className="text-[0.7rem] ml-2">
          {post.post.comment ? post.post.comment.length : 0} Comments
        </p>
      </CardActions>
    </Card>
  );
}
